'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _common = require('../common');

var _WMTableRow = require('../WMTableRow');

var _WMTableRow2 = _interopRequireDefault(_WMTableRow);

var _WMTableCell = require('../WMTableCell');

var _WMTableCell2 = _interopRequireDefault(_WMTableCell);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	hideDisabledCheckboxes: _propTypes2.default.bool,
	children: _propTypes2.default.node.isRequired,
	columnAlignment: _propTypes2.default.array.isRequired,
	striped: _propTypes2.default.bool,
	selectable: _propTypes2.default.bool
};

var WMTableBody = function WMTableBody(props) {
	return _react2.default.createElement(
		'div',
		{
			'data-component-identifier': 'wm-table-body',
			style: _styles2.default.body
		},
		_react2.default.Children.map((0, _common.Arrayify)(props.children).filter(function (child) {
			return child;
		}), function (row, rowIndex) {
			return _react2.default.createElement(
				_WMTableRow2.default,
				{
					key: rowIndex,
					style: Object.assign({}, _styles2.default.row(props), row.props.style),
					striped: Boolean(props.striped && rowIndex % 2 === 0),
					hideDisabledCheckboxes: props.hideDisabledCheckboxes,
					selectable: props.selectable,
					selected: row.props.selected,
					onSelectRow: row.props.onSelectRow
				},
				(0, _common.Arrayify)(row.props.children).filter(function (child) {
					return child;
				}).map(function (cell, cellIndex) {
					return _react2.default.createElement(
						_WMTableCell2.default,
						{
							first: cellIndex === 0 && !props.selectable && props.hideDisabledCheckboxes,
							right: props.columnAlignment[cellIndex],
							key: cellIndex,
							style: cell.props.style
						},
						cell.props.children
					);
				})
			);
		})
	);
};

WMTableBody.defaultProps = { columnAlignment: [] };

exports.default = (0, _radium2.default)(WMTableBody);


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableBody/index.js